import TitleStripe from "../../common/TitleStripe";
import NoOcurrence from "../../common/query/NoOcurrence";
import PendenciasFinanceiras from "../../common/query/PendenciasFinanceiras";
import Protestos from "../../common/query/Protestos";
import ChequesSemFundos from "../../common/query/ChequesSemFundos";
import ParticipacaoEmEmpresas from "../../common/query/ParticipacaoEmEmpresas";
import {
  countDadosCadastrais,
  countScore,
  formatDocument,
  getColorScore,
  getImageURLScoreSerasa,
  maskCEP,
} from "../../../utils/utils";
import QuadroSocietario from "../../common/query/QuadroSocietario";
import HistoricoConsultas from "../../common/query/HistoricoConsultas";
import Enderecos from "../../common/query/Enderecos";
import Telefones from "../../common/query/Telefones";
import Emails from "../../common/query/Emails";
import { HiOutlineEye } from "react-icons/hi";
import { useState } from "react";
import { Modal } from "flowbite-react";
import StreetView from "../../common/query/StreetView";
import ModalReceitaFederal from "../../modals/ModalReceitaFederal";
import ScoreRating from "./ScoreRating";

const SpcMixTopQuery = ({ data, dataFull }) => {
  const [openMap, setOpenMap] = useState(false);

  const fullAddress = [
    data?.dadosCadastrais?.endereco,
    data?.dadosCadastrais?.numero,
    data?.dadosCadastrais?.bairro,
    data?.dadosCadastrais?.cidade,
    data?.dadosCadastrais?.cep,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <>
      <div>
        <TitleStripe>Dados Cadastrais</TitleStripe>

        {data?.dadosCadastrais?.cnpj && (
          <div className="mt-4 grid grid-cols-2 gap-6 bg-white border border-gray-200 rounded-xl p-6 shadow-sm text-sm">
            <div>
              <div className="text-gray-500 text-xs uppercase">
                Razão Social
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.razaoSocial || "Indisponível"}
              </div>
              <ModalReceitaFederal cnpj={data?.dadosCadastrais?.cnpj} />
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">
                Nome Fantasia
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.nomeFantasia || "Indisponível"}
              </div>
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">CNPJ/MF</div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.cnpj
                  ? formatDocument(data?.dadosCadastrais?.cnpj)
                  : "Indisponível"}
              </div>
            </div>

            <div>
              <div className="text-gray-500 text-xs uppercase">
                CNAE Principal
              </div>
              <div className="font-medium text-gray-900">
                {data?.dadosCadastrais?.ramoAtividade || "Indisponível"}
              </div>
            </div>
          </div>
        )}
      </div>

      {data?.dadosCadastrais?.cpf && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 text-sm border border-gray-200 rounded-xl overflow-hidden">
          {[
            { label: "Nome completo", value: data?.dadosCadastrais?.nome },
            { label: "CPF", value: formatDocument(data?.dadosCadastrais?.cpf) },
            { label: "Origem CPF", value: data?.dadosCadastrais?.regiaoCPF },
            {
              label: "Data de nascimento",
              value: data?.dadosCadastrais?.dataNascimento,
            },
          ].map((item, index) => (
            <div
              key={index}
              className={`p-4 border-b border-gray-200 ${
                (index + 1) % 3 === 0 ? "sm:border-r-0" : "sm:border-r"
              }`}
            >
              <p className="text-gray-500 text-xs mb-1">{item.label}</p>
              {item.isStatus ? (
                <span
                  className={`font-semibold text-sm px-2 py-0.5 rounded-md text-white inline-block ${
                    item.value?.toUpperCase() === "REGULAR"
                      ? "bg-blue-800"
                      : "bg-red-500"
                  }`}
                >
                  {item.value || "Indisponível"}
                </span>
              ) : (
                <p className="font-medium text-gray-800">
                  {typeof item.value === "string"
                    ? item.value?.trim() || "Indisponível"
                    : item.value || "Indisponível"}
                </p>
              )}
            </div>
          ))}
        </div>
      )}

      <div>
        <TitleStripe className="mb-5">Endereços</TitleStripe>

        {data?.enderecos?.length > 0 ? (
          <>
            <Enderecos enderecos={data?.enderecos} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">Telefones</TitleStripe>

        {data?.telefones?.length > 0 ? (
          <>
            <Telefones telefones={data?.telefones} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      {dataFull?.scoreRating?.statusRetorno == 1 && (
        <ScoreRating score={dataFull?.scoreRating} block={false} />
      )}

      <div>
        <TitleStripe className="mb-5">Pendências/Restrições Ativas</TitleStripe>

        {data?.spc?.length > 0 ? (
          <>
            <PendenciasFinanceiras
              quantidadeTotal={data?.resumoConsulta?.spc?.quantidadeTotal}
              valorTotal={data?.resumoConsulta?.spc?.valorTotal}
              pendenciasFinanceiras={data?.spc}
            />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">Cheques sem fundos</TitleStripe>

        {data?.chequesSemFundo?.length > 0 ? (
          <>
            <ChequesSemFundos chequesSemFundos={data?.chequesSemFundo} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>

      <div>
        <TitleStripe className="mb-5">Histórico de Consultas</TitleStripe>

        {data?.historicoConsultas?.length > 0 ? (
          <>
            <HistoricoConsultas historicoConsultas={data?.historicoConsultas} />
          </>
        ) : (
          <NoOcurrence />
        )}
      </div>
      <Modal show={openMap} onClose={() => setOpenMap(false)} size="5xl">
        <Modal.Header>Localização</Modal.Header>
        <Modal.Body>
          <div className="space-y-2">
            <div className="text-sm text-gray-600">
              <strong>Endereço:</strong> {fullAddress || "—"}
            </div>
            {fullAddress ? (
              <StreetView address={fullAddress} height={460} />
            ) : (
              <div className="p-3 text-sm text-gray-500">
                Endereço indisponível.
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SpcMixTopQuery;
